module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.allowed) ? _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v("\nPlease send the payment to "), _c('b', [_vm._v("paypal@unlocklounge.com")]), _vm._v(" and paste the transaction id below\n"), _c('br'), _vm._v("\n*Gift or mass "), _c('b', [_vm._v("ONLY")]), _vm._v("!\n"), _c('div', {
    staticClass: "paymentdiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txnid),
      expression: "txnid"
    }],
    attrs: {
      "placeholder": "Please enter transaction id"
    },
    domProps: {
      "value": (_vm.txnid)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.txnid = $event.target.value
      }, _vm.txnidLength]
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.showSubmitButton,
      "color": "info"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitPayment($event)
      }
    }
  }, [_vm._v("Process Payment")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serverResponse)
    }
  })], 1)]) : _c('div', [_vm._v("\nPlease contact your reseller to add credits\n")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "10",
      "cellspacing": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.paypal.com/eg/webapps/mpp/paypal-popup",
      "title": "How PayPal Works",
      "onclick": "javascript:window.open('https://www.paypal.com/eg/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png",
      "border": "0",
      "alt": "PayPal Logo"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb33c74c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AddCredits.vue
// module id = 412
// module chunks = 1